import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-5 text-2xl font-bold" }
const _hoisted_4 = { class: "pt-5 flex flex-col" }
const _hoisted_5 = { class: "pt-5 flex flex-col" }
const _hoisted_6 = { class: "pt-5 flex flex-col" }
const _hoisted_7 = { class: "pt-5 flex flex-col" }
const _hoisted_8 = { class: "pt-5 flex flex-col" }
const _hoisted_9 = { class: "flex pt-3 justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.id? 'Dettaglio': 'Nuova') + " attività timesheet ", 1),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([[_ctx.esito ? 'bg-next-bri' : 'bg-next-orange'], "text-white p-3 mb-3 flex justify-between items-center"])
      }, [
        _createTextVNode(_toDisplayString(_ctx.response_message) + " ", 1),
        _createElementVNode("i", {
          class: "icon-x cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.response_message = ''))
        })
      ], 2), [
        [_vShow, _ctx.response_message.length]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Field, {
          field_name: "Voce timesheet",
          errors: _ctx.getErrors('voce_spesa_id')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.voceTimesheetAutocomplete.selection,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.voceTimesheetAutocomplete.selection) = $event)),
              options: _ctx.voceTimesheetAutocomplete.options,
              placeholder: "Voce di spesa",
              class: "next-vue-multiselect-single",
              "track-by": "id",
              label: "descrizione",
              selectLabel: "",
              deselectLabel: "",
              selectedLabel: "",
              "internal-search": false,
              onSearchChange: _ctx.voceTimesheetAutocomplete.search
            }, null, 8, ["modelValue", "options", "onSearchChange"])
          ]),
          _: 1
        }, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Field, {
          field_name: "Business unit",
          errors: _ctx.getErrors('business_unit')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.buAutocomplete.selection,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
              options: _ctx.buAutocomplete.options,
              placeholder: "Business unit",
              class: "next-vue-multiselect-single",
              "track-by": "id",
              label: "nome",
              selectLabel: "",
              deselectLabel: "",
              selectedLabel: "",
              "internal-search": false,
              onSearchChange: _ctx.buAutocomplete.search
            }, null, 8, ["modelValue", "options", "onSearchChange"])
          ]),
          _: 1
        }, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Field, {
          field_name: "Voce di spesa",
          errors: _ctx.getErrors('voce_spesa_id')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.vocespesaAutocomplete.selection,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vocespesaAutocomplete.selection) = $event)),
              options: _ctx.vocespesaAutocomplete.options,
              placeholder: "Voce di spesa",
              class: "next-vue-multiselect-single",
              "track-by": "id",
              label: "descrizione",
              selectLabel: "",
              deselectLabel: "",
              selectedLabel: "",
              "internal-search": false,
              onSearchChange: _ctx.vocespesaAutocomplete.search
            }, null, 8, ["modelValue", "options", "onSearchChange"])
          ]),
          _: 1
        }, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Checkbox, {
          checkClass: "h-3 w-3",
          checked: _ctx.visible_attivita_generale,
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.visible_attivita_generale = !_ctx.visible_attivita_generale))
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Visibile come attivita timesheet generale ")
          ])),
          _: 1
        }, 8, ["checked"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Checkbox, {
          checkClass: "h-3 w-3",
          checked: _ctx.visible_attivita_sottoprogetto,
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.visible_attivita_sottoprogetto = !_ctx.visible_attivita_sottoprogetto))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode(" Visibile come attivita timesheet dei sottoprogetti ")
          ])),
          _: 1
        }, 8, ["checked"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _withDirectives(_createVNode(_component_NextButton, {
            class: "px-3 py-2",
            onClick: _ctx.cancella
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Cancella")
            ])),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.id]
          ])
        ]),
        _createVNode(_component_NextButton, {
          class: "px-3 py-2",
          onClick: _ctx.save
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("Salva")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}